// (function autoCloseDetails() {
//   document.addEventListener('click', function (event) {
//     const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
//       (element) => {
//         const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
//         return (
//           element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
//           !(event.target instanceof Node && element.contains(event.target))
//         );
//       }
//     );

//     for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
//   });
// })();

(function detailsHoverDesktopClickMobile() {
  const detailsElements = document.querySelectorAll('details.facets__panel');

  detailsElements.forEach((details) => {
    // Open on hover (desktop only)
    details.addEventListener('mouseenter', () => {
      if (window.innerWidth >= 750) { // Desktop
        if (details.getAttribute('data-auto-close-details')?.includes('desktop')) {
          details.setAttribute('open', ''); // Force open
        }
      }
    });

    // Close on hover out (desktop only)
    details.addEventListener('mouseleave', () => {
      if (window.innerWidth >= 750) { // Desktop
        if (details.getAttribute('data-auto-close-details')?.includes('desktop')) {
          details.removeAttribute('open'); // Close when leaving
        }
      }
    });

    // On mobile: do nothing → <details> keeps native click-to-toggle
  });
})();
